import { Link } from "react-router-dom";
import { FormGroup, Input } from "reactstrap";
import { Btn, H6, Image } from "../../../../../AbstractElements";
import { RecentOrdersData } from "../../../../../Data/General/Dashboard/ECommerce";
import { dynamicImage } from "../../../../../Utils";
import { CommonDropdown } from "../../../../CommonComponents/CommonDropdown/CommonDropdown";

export const RecentOrdersTableBody = () => {
  return (
    <tbody>
      {RecentOrdersData.map((item, index) => (
        <tr key={index}>
          <td className="checkbox-checked">
            <FormGroup check>
              <Input type="checkbox" />
            </FormGroup>
          </td>
          <td>
            <div className="user-data d-flex gap-2">
              <div>
                <Image src={dynamicImage(item.image)} alt="product" />
              </div>
              <div>
                <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                  <H6>{item.title}</H6>
                  <span>{item.text}</span>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <div className="user-time">
              <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                <H6>{item.date}</H6>
                <span>{item.time}</span>
              </Link>
            </div>
          </td>
          <td><span>{item.customer}</span></td>
          <td><span>{item.price}</span></td>
          <td><Btn color={item.color}>{item.status}</Btn></td>
          <td><CommonDropdown dropdownClass="dropdown-toggle" /></td>
        </tr>
      ))}
    </tbody>
  );
};
